import { FieldsIcon } from '@gocanvas/gcds/icons'
import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel'
import { BackgroundColor as defaultBackgroundColorConfig } from 'apps/studio/components/settings/fields/Base/design'
import { sheetsSelector } from 'apps/formsCreationKit/store/selectors/entities'
import { ensureUniqueDescription } from 'apps/builder/lib/utils'

export const BackgroundColor = {
  ...defaultBackgroundColorConfig,
  updateType: 'pageStyles',
}

export const ScreenName = {
  label: 'Screen Name',
  settingType: 'longTextInput',
  updateType: 'sheet',
  property: 'description',
  additionalClasses: 'textarea--constrained',
  validationFunction: (sheetId, updatedValue, state) => {
    const sheets = sheetsSelector(state) || []
    return ensureUniqueDescription(sheets, updatedValue, sheetId)
  },
}

export const PageStandardSettings = [
  ScreenName,
  SettingsLabel('Design'),
  BackgroundColor,
]

export const PAGE_SETTINGS_PANEL = 'Page'

export const PageSettingsPanel = (settings = []) => ({
  label: PAGE_SETTINGS_PANEL,
  icon: FieldsIcon,
  settings,
})
